import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';

export default function Heading({ index, item, handleSettingsClick, isFormBuilder }) {
  const name = `form_data.${index}.heading`;
  const {
    watch,
    control,
    formState: { errors },
  } = useFormContext();
  const heading = watch(name);

  return (
    <div className="w-100">
      {heading ? (
        <h3 className="w-100 mb-0" style={{ textAlign: item?.alignment }}>
          {heading}
        </h3>
      ) : (
        <h3 className="mb-0 cursor-pointer" onClick={() => handleSettingsClick(item)}>
          Click to edit text
        </h3>
      )}
      {isFormBuilder && (
        <span className="w-100">
          <Controller
            name={name}
            control={control}
            rules={{ required: true }}
            render={({ field }) => <input ref={field.ref} type="hidden" value={field.value || ''} onChange={field.onChange} />}
          />
          <RequiredValidation field={name} errors={errors} message="Heading not added" />
        </span>
      )}
    </div>
  );
}
